import React, { Component } from 'react';
import $ from 'jquery';
import Eventpopup from './popup/Eventpopup';
import Eventaddpopup from './popup/Eventaddpopup';
import Lightningpopup from './popup/Lightningpopup';
import {
  isMobile, isIOS
} from "react-device-detect";
import {getUrlVars,getiOS} from './helper/format';

//dHYraFJOMFZzS24vblNvUXdKMUtZL2lleUtUOUlMSXZaZmZhVjRPSFIrUT0=

class Login extends Component {

  constructor(props)
  {
    super(props);
    this.loginKey = sessionStorage.getItem('loginKey');
    this.data = getUrlVars();
    if( this.data.session == "mobile" )
    {

    }


    if(  localStorage.getItem('loginKey') && localStorage.getItem('loginKey') != "" )
    {
        this.reportMoveKey();
        return false;
    }

    if(!isMobile){
        window.location.href = '//v2.tfamily.co.kr/';
        return;
    }
    console.log(this.data);

  }
  componentDidMount()
  {
    if(!isIOS)
    {
  //    this.checkPopup();
    }
      this.checkPopup();
    //window.webkit.messageHandlers.updateKey.postMessage('1234');
    //session
  }
  movePage()
  {
      window.location.href = '/';
  }
  reportMoveKey()
  {
    //alert(window.AndroidApp);
    if( window.AndroidApp !== undefined)
    {
        let androidKey = window.AndroidApp.getPushKey();
        //alert(localStorage.getItem('loginKey'));
        $.post('https://api.tfamily.co.kr/api/mobile/updatePushKey',{
          push_key: androidKey,
          uk: localStorage.getItem('loginKey')
        },function(data){
          //alert(data);
          window.location.href = '/Option';
        });
    } else {
      if( getiOS() )
      {
        let loginKey = localStorage.getItem('loginKey');
        window.webkit.messageHandlers.updateKey.postMessage(localStorage.getItem('loginKey'));
      }
      window.location.href = '/Option';
    }
  }
  moveLogin()
  {
      window.location.href = '/Login';
  }
  orderPage()
  {
      window.location.href = '/Option'
  }
  checkPopup()
  {
    const self = this;
    $.post('https://api.tfamily.co.kr/api/mobile/init',{},function(data){
      let pData = JSON.parse(data);
      if(pData.data && pData.data.popup)
      {
        if( pData.data.popup.length > 0 )
        {
          let first_popup = (pData.data.popup[0]);
          if( first_popup ) {
            let resultPopup = window.getCookie('popup' + first_popup.idx);
            if( resultPopup != 1 )
            {
                self._eventPopup.Open(pData.data.popup);
            }
          }
        }
      }
    });
  }

  onJoinChanged(_title)
  {
    this._eventPopup.Close();
    /*
    if( this.loginKey && this.loginKey != "") {
        this._eventAddpopup.Open(_title);
    } else {
      alert('로그인이 필요합니다');
    }
    */
    this._eventAddpopup.Open(_title);
  }
  onPasswordChanged(e)
  {
    if(e.keyCode == 13)
    {
      this.login();
      return false;
    }
  }
  login()
  {
      const self = this;
      let email = document.getElementById('email'), passwd = document.getElementById('passwd');
      $.post('https://api.tfamily.co.kr/api/main/login',{
        email: email.value,
        passwd: passwd.value
      },function(data){
        const parsedData = JSON.parse(data);
        if( parsedData.error_code == 200 )
        {
          if( parsedData.data.status == 'A') {
            sessionStorage.setItem('loginKey', parsedData.data.uk);
            sessionStorage.setItem('logo', parsedData.data.company_logo);
            if( self.data.session == "mobile" )
            {
              localStorage.setItem('loginKey', parsedData.data.uk);
              localStorage.setItem('logo', parsedData.data.company_logo);
            }
            self.reportMoveKey();
            //window.location.href = '/Option';
          } else {
            if( parsedData.data.status == 'D') {
                alert('제출 하신 서류가 반려되었습니다. ')
            } else {
                alert('제출 하신 서류를 검토중입니다. ')
            }
          }
        } else {
          alert('계정 정보가 올바르지 않습니다.');
        }
      });
  }
  logout()
  {
    sessionStorage.setItem('loginKey', '');
    sessionStorage.setItem('logo', '');
    this.moveLogin();
  }
  render() {
    const self = this;
    let height = $(document).height();
    let footFixed = true;
    //console.log(height);
    if( height < 900)
    {
      footFixed = false;
    }
    footFixed = false;
    return(
      <div>

        <div className="centralize-wrapper bgGray">
          <div className="centralize-inner">
            <div className="centralize-content">
              <div className="login-box">
                <div className="login-box-body">
                {(!this.loginKey || this.loginKey == "") ?
                    <div className="rowBox">
                    <div className="mlm25">
                      {(this.data.session=="mobile") ?  null : <img className="img-responsive" src={'img/logo.png'} /> }
                    </div>
                    <div className="pb30 minusGuide">
                    T패밀리몰은 사전 승인된 고객사 및 협회 등의 <span className="txtGood">임직원 및 가족을 위한 공간</span>입니다. <br/>
                    <div className="pt5"><span className="txtGood">최고의 혜택</span>과 <span className="txtGood">서비스</span>를 누려보세요.</div>
                    </div>
                    <div className="row pb30">
                      <span className="redpoint"></span>
                      <h1 className="mb0 mt5"><b>로그인</b></h1>
                      <div>환영합니다</div>
                      {(this.data.guide) ? <div className="pd-t-5" style={{marginTop:"10px"}}><b className="txtGood">기존 아이디</b>로 로그인 하실 수 있습니다.</div> : null }
                    </div>
                    <form className="mt10">
                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="email"><b>이메일</b></label>
                          <input type="email" className="form-control loginform" id="email" placeholder="이메일을 입력해주세요"/>
                        </div>
                      </div>
                      <div className="form-group mt30">
                        <div className="row">
                          <label htmlFor="passwd"><b>비밀번호</b></label>
                          <input type="password" className="form-control loginform Arial" id="passwd" onKeyDown={self.onPasswordChanged.bind(this)} placeholder="비밀번호를 입력해주세요"/>
                        </div>
                      </div>
                      <div className="form-group mt30">
                        <div className="row">
                          <a onClick={()=>{self.login()}} className="col-xs-12 btn btn-baru">로그인</a>
                        </div>
                      </div>
                      <div className="form-group mt20">
                        <div className="row">
                          <div className="form-left">
                            <a className="link" href={'/Signup'}>회원가입</a>
                          </div>

                          <div className="form-right">
                            <a className="link" href={'/Reset'}>비밀번호재설정</a>
                          </div>

                          <div className="clearboth"></div>
                        </div>
                      </div>
                    </form>
                    </div>
                 : <div>
                   <div className="row pb30 norow">
                     <span className="redpoint"></span>
                     <h1 className="mb0 mt5"><b>반갑습니다</b></h1>
                     <div>환영합니다</div>
                     <br/>
                     <br/>
                     <div className="row">
                       <a onClick={()=>{self.orderPage()}} className="col-xs-12 btn btn-primary">주문페이지</a>
                     </div>
                     <br/>
                     <div className="row">
                       <a onClick={()=>{self.logout()}} className="col-xs-12 btn btn-default">로그아웃</a>
                     </div>
                   </div>
                   </div>}
                </div>
              </div>
            </div>

            <div className={ (isMobile || !footFixed) ? 'footerClass2' : 'footerClass' }>
              <div className="container">
                <div className="col-xs-12">
                  <div className="row pt15 pb15">

                    <div className="col-md-4">

                    </div>
                    <div className="col-xs-12 col-md-4 text-left">
                      <ul className="nonelist col-small">
                        <li>가입 및 상담 대표 번호 TEL: 1599-5168</li>
                        <li>아이디 및 비밀번호 분실시 대표 번호로 문의 바랍니다.</li>
                        <li>카카오 플러스 친구 "T패밀리몰" 검색</li>
                        <li><a href="/agree/our.html">서비스 이용약관</a>,
                        <a href="/agree/private.html">개인정보 취급방침</a></li>
                        <li>개인정보 보호책임자 : 팀장 이지범</li>
                        <li>통신판매업 : 제2020-대구수성구-0289호</li>
                      </ul>
                    </div>

                    <div className="col-xs-12 col-md-4 col-small">
                      <ul className="nonelist">
                        <li>근무시간 : 평일 09시 ~ 20시</li>
                        <li>토요일 및 공휴일 11시 ~ 20시(일요일 휴무)</li>
                        <li>E-MAIL: 216-2265@naver.com</li>
                        <li>바른정보통신(사업자번호 : 662-88-00280) 대표자 : 최형종</li>
                        <li>대구시 수성구 달구벌대로 2349 수협G타워 901호</li>
                      </ul>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
          <Eventpopup onJoinChanged={(title)=>{self.onJoinChanged(title)}}  ref={(ref=>{this._eventPopup=ref;})} />
          <Eventaddpopup ref={(ref)=>{this._eventAddpopup=ref}} />

          <Lightningpopup ref={(ref)=>{this._lightingpopup=ref}} />
        </div>



      </div>
    );
  }
}

export default Login;
